import { Box } from '@mui/material';

import UsersListDialogs from './components/UsersListDialogs';
import { UsersListHeader } from './components/UsersListHeader';
import { UsersListTable } from './components/UsersListTable';
import { UsersListDialogProvider } from './context/UsersListDialogContext';

const UsersList = () => {
  return (
    <UsersListDialogProvider>
      <Box>
        <UsersListHeader />
        <UsersListTable />
        <UsersListDialogs />
      </Box>
    </UsersListDialogProvider>
  );
};

export default UsersList;
